import { render, staticRenderFns } from "./POSAlert.vue?vue&type=template&id=6b6d053c&scoped=true"
import script from "./POSAlert.vue?vue&type=script&lang=js"
export * from "./POSAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d053c",
  null
  
)

export default component.exports